import * as React from "react";
import {formatDateTime, getAmountWithDecimalDigits} from "../../CommonFunctions";
import {Link} from "react-router-dom";
import {
    Policy,
    PREMIUM_TYPE_ANNUAL,
    PREMIUM_TYPE_MONTHLY,
    Renewal,
    RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL
} from "@ferry/journey-services";
import {InfoBanner} from "@ferry/portal-core";

interface IProps {
    renewalProposal: Renewal;
    vehicle?: any;
    policy: Policy;
}

interface IState {
}

export class GracePeriodBanner extends React.Component<IProps, IState> {

    public render() {
        const premiumType: string = this.props.renewalProposal.factors.premiumType;

        return (
            <InfoBanner wording={
                <>
                    <p>
                        You are no longer covered. Your <strong>car insurance policy for{' '}
                        {this.props.vehicle?.make} {this.props.vehicle?.model}{' '}
                        ended on {formatDateTime(this.props.policy.endDate)}.</strong> You can still
                        renew your policy up to 5 days after expiry date.
                    </p>
                    <div className="pt-20">
                        Set up your renewal for{" "}
                        {premiumType === PREMIUM_TYPE_ANNUAL &&
                            <>
                                {getAmountWithDecimalDigits(this.props.renewalProposal.factors.annualPremium)} / year.
                            </>
                        }
                        {premiumType === PREMIUM_TYPE_MONTHLY &&
                            <>
                                {getAmountWithDecimalDigits(this.props.renewalProposal.paymentDetails.instalmentPlan.monthlyPayment)} / month
                                ({getAmountWithDecimalDigits(this.props.renewalProposal.paymentDetails.instalmentPlan.totalAmount)} total).
                            </>
                        }
                    </div>
                    <div className="row mt-2">
                        <div className="col-12">
                            <div className="mt-2">
                                <Link className="btn btn-primary m-auto text-decoration-none btn-text"
                                      to={RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL + this.props.renewalProposal._id}>
                                    Renew your policy now
                                </Link>
                            </div>
                        </div>
                    </div>
                </>
            }/>
        )
    }
}


